export default function addNamespace(types: {[key: string]: string}, namespace: string) {
    let newTypes = {} as {[key: string]: string};

    Object.keys(types).forEach((key) => {
        newTypes[key] = namespace.toUpperCase() + '/' + types[key];
    });

    return newTypes;
};